import { useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { coverEditorPath } from '../coverEditorPath';

/**
 * Opens the cover editor of a song. In the same tab, "Back" of the editor comes to this page
 * (`from`). With `newTab` (a wizard: it keeps its own state, design a4) the editor opens in a new
 * tab, and "Back" goes to the song page.
 */
export function useOpenCoverEditor(input: { accountId: number; newTab?: boolean }) {
  const navigate = useNavigate();
  const { pathname, search } = useLocation();
  const { accountId, newTab = false } = input;
  return useCallback(
    (catalogItemUuid: string) => {
      if (newTab) {
        window.open(`/app${coverEditorPath(catalogItemUuid, { accountId })}`, '_blank', 'noopener');
        return;
      }
      // The router paths have no `/app`: the editor gets the path of this page as react-router has it.
      // eslint-disable-next-line no-void -- a router navigation: nothing to wait for
      void navigate(coverEditorPath(catalogItemUuid, { accountId, from: `${pathname}${search}` }));
    },
    [accountId, navigate, newTab, pathname, search]
  );
}
